
import {DATA_SHIPPING_OPT} from './shippingOptType'
// import 
export function myownShippingOpt(data,True){
    // console.log(True);
    return async (dispatch) => (    
                    dispatch({type:DATA_SHIPPING_OPT,payload:{data,True}})
    );
  }